/**
 * @fileoverview Really basic placeholder component to use for things that aren't implemented yet.
 */

import { elt } from '../dom';

export class Placeholder extends HTMLElement {
  static tag: string = 'rebuild-placeholder';

  static register() {
    if (!customElements.get(Placeholder.tag)) {
      customElements.define(Placeholder.tag, Placeholder);
    }
  }

  static createElement(options?, ...body): Placeholder {
    return elt(Placeholder.tag, options, ...body);
  }

  static get observedAttributes() {
      return ['title'];
  }

  heading: HTMLHeadingElement;

  connectedCallback() {
    if (!this.heading) {
      this.heading = elt('h2');
      this.append(this.heading);
    }

    this.update();
  }

  attributeChangedCallback() {
    this.update();
  }

  update() {
    if (!this.heading) {
      return;
    }

    const title = this.getAttribute('title') || '';
    this.heading.textContent = title;
  }
}